import { render, staticRenderFns } from "./BaseNavigationButtons.vue?vue&type=template&id=05651442"
import script from "./BaseNavigationButtons.vue?vue&type=script&lang=js"
export * from "./BaseNavigationButtons.vue?vue&type=script&lang=js"
import style0 from "./BaseNavigationButtons.vue?vue&type=style&index=0&id=05651442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports